// extracted by mini-css-extract-plugin
export default {"icon":"icon_OWCSlRH8","list":"list_WbfbMt5a"};